import SourceItem from "../SourceItem/SourceItem";
import { SourceHealthCell } from "@/components/HealthDashboard/HealthDashboardTable/SourceHealthCell";

interface SourceListCardProps {
    title: string;
    percentage: number;
    sources: any[];
	isColumnView?: boolean;
	disabledCard?: boolean;
	enabledAnnotation?: boolean;
	resetAnnotationIcon?: boolean;
	onAnnotationToggle?: (isActive: boolean, sourceKey?: string, sourceSerialNumber?: string) => void;
	activeAnnotationIcon?: string | null;
}


const SourceListCard: React.FC<SourceListCardProps> = ({ title, percentage, sources, isColumnView = false, disabledCard = false, enabledAnnotation = false, resetAnnotationIcon = false, onAnnotationToggle = () => {}, activeAnnotationIcon = null }) => {
	
	// Check if all items are checked
	const allItemsChecked = sources.length > 0 && sources.every(source => source.checked);
	// Check if all items are unchecked
	const allItemsUnchecked = sources.length > 0 && sources.every(source => !source.checked);
	
	return (
		<div className={`w-full flex-1 p-2 rounded-lg flex ${isColumnView ? 'flex-col' : 'flex-row items-center'} justify-start border border-[#E5E7EB] gap-4 text-gray-900 ${disabledCard ? 'opacity-50' : ''}`}>
			<div className="inline-flex flex-col justify-start items-start gap-2">
				<div className="justify-center text-[#74788D] text-[10px] font-normal leading-3">
					{title}
				</div>
				{/* {sources.length > 2 && (
					<div className="inline-flex justify-start items-end gap-2">
						<SourceHealthCell health={percentage} size="sm" />
					</div>
				)} */}
			</div>
			<div className="flex-1 flex justify-start items-start gap-2 flex-wrap content-start">
                {sources.map((source, index) => {
					// Create unique key for each source annotation icon
					const sourceKey = `${source.parameterId}-${source.sourceId || 'recommended'}-${source.serialNumber || 'null'}`;
					// Use stable key based on source identifiers
					const itemKey = `item-${source.parameterId}-${source.sourceId || 'rec'}-${source.serialNumber || 'null'}`;
					
					return (
						<SourceItem
							key={itemKey}
							title={source.name}
							sourceLineColor={source.color}
							tooltip={source.tooltip}
							source={source}
							isLast={index === sources.length - 1}
							checked={source.checked}
							onCheck={source.onCheck}
							enabledAnnotation={enabledAnnotation}
							onAddAnnotation={source.onAddAnnotation}
							disabled={disabledCard}
							resetAnnotationIcon={resetAnnotationIcon}
							onAnnotationToggle={(isActive) => onAnnotationToggle(isActive, sourceKey, source.serialNumber)}
							allItemsUnchecked={allItemsUnchecked}
							sourceKey={sourceKey}
							activeAnnotationIcon={activeAnnotationIcon}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default SourceListCard;
